$(function () {
	function applyMatchHeight() {
		// まず、matchHeightのリセット
		$('.matchheight_box-01, .matchheight_box-02, .matchheight_box-03, .matchheight_box-04, .matchheight_box-05, .matchheight_box--lg-01, .matchheight_box--lg-02, .matchheight_box--lg-03, .matchheight_box--lg-04, .matchheight_box--lg-05').css('height', '');

		if (window.matchMedia('(min-width: 1024px)').matches) {
			$('.matchheight_box-01').matchHeight();
			$('.matchheight_box-02').matchHeight();
			$('.matchheight_box-03').matchHeight();
			$('.matchheight_box-04').matchHeight();
			$('.matchheight_box-05').matchHeight();
		}

        $('.matchheight_box--pc-sp').matchHeight();
        $('.matchheight_box--pc-sp-01').matchHeight();
        $('.matchheight_box--pc-sp-02').matchHeight();
	}

	applyMatchHeight();
	$(window).on('resize orientationchange', function () {
		applyMatchHeight();
	});
});

$(document).ready(function() {
    $('.matchheight_box--pc-sp__dom').matchHeight();
});
